import React from "react";
import styles from "@/components/Loader/Loader.module.css";
import { Spinner } from "@fluentui/react-components";
import type { LoaderProps } from "@/components/Loader/Loader.types";

export const Loader = React.memo(({ label }: LoaderProps) => {
  return (
    <div className={styles.loaderContainer}>
      <Spinner label={label} />
    </div>
  );
});
